export const ONBOARDING_PATH = "/issuer/onboarding";

export const ONBOARDING_ELIGIBLE_ROLES = ["admin", "issuer"];

export const isOnboardingEligibleRole = (userRole) =>
  ONBOARDING_ELIGIBLE_ROLES.includes(userRole?.toLowerCase?.() || "");

export const shouldStartOnboarding = (permissions, userRole) =>
  permissions?.is_new_user_onboarding === true &&
  isOnboardingEligibleRole(userRole);

// Goal and Organisation are setup; Get started is not.
export const isOnboardingSetupPath = (pathname, search = "") => {
  if (!pathname?.startsWith(ONBOARDING_PATH)) {
    return false;
  }
  return new URLSearchParams(search).get("step") !== "get-started";
};
